import {
    Box,
    Button, Flex, Icon, Spinner, Text, useDisclosure
} from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { FaSync } from 'react-icons/fa';
import { toast } from "react-toastify";
import { getAllPaginated } from 'services/ModelService';
import { getAll as getAllModelTypes } from 'services/ModelTypeService';
import { Filters, GetModelPaginatedRs, GetModelTypeRs } from 'utils/interfaces';
import NewModelModal from './components/modal/NewModelModal';
import ModelCardGrid from './components/ModelCardGrid';
import ModelsFilter from './components/ModelsFilter';

export default function Models() {

    const [models, setModels] = useState<GetModelPaginatedRs>();
    const [loading, setLoading] = useState<boolean>(false);
    const [modelTypes, setModelTypes] = useState<GetModelTypeRs[]>([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    // FILTERS
    const [filters, setFilters] = useState<Filters<any>>({
        pageNumber: 0,
        modelTypeId: null,
        modelName: null,
    });

    const { keycloak } = useKeycloak();

    useEffect(() => {
        fetchModelTypes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSessionExpired = () => {
        toast.error("Sessione scaduta. Effettua nuovamente l'accesso.", {
            position: "bottom-right",
            onClose: () => {
                keycloak.logout();
                localStorage.removeItem("kc-token");
            }
        });
    };

    const fetchModels = async () => {
        setLoading(true);
        try {
            const modelsData = await getAllPaginated(
                keycloak.token,
                onSessionExpired,
                filters
            );

            setModels(modelsData);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchModelTypes = async () => {
        try {
            const modelTypes: GetModelTypeRs[] = await getAllModelTypes(keycloak.token, onSessionExpired);
            if (modelTypes) {
                setModelTypes(modelTypes);
            }
        } catch (error) {
            console.error("Error fetching model types:", error);
        }
    };

    const onCloseWithFetch = () => {
        onClose();
        fetchModels();
    };

    return (
        <Box>
            <Text color="#9FB50C" fontSize="22px" fontWeight="700" lineHeight="100%" pb={4}>
                Gestione Modelli
            </Text>
            <ModelsFilter setFilters={setFilters} modelTypes={modelTypes} />
            <Flex justifyContent="space-between" alignItems="center" mb={4} mt={10}>
                <Text fontWeight='bold'>
                    Tutti i modelli ({models?.totalElements})
                </Text>
                <Flex alignItems={"center"}>
                    <Button
                        onClick={onOpen}
                        _hover={{ bg: "gray.700" }}
                        _active={{ bg: "gray.600" }}
                        _focus={{ boxShadow: "none" }}
                        backgroundColor="#688CC8"
                        color="white"
                        style={{
                            height: "30px",
                            padding: "0px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                        }}
                        fontSize="xs"
                        mx="1"
                    >
                        + Crea Modello
                    </Button>
                    <Button
                        onClick={() => fetchModels()}
                        variant="ghost"
                        colorScheme="blue"
                        mx="1"
                        p={2}
                        _hover={{ bg: 'gray.200' }}
                    >
                        <Icon as={FaSync} w={5} h={5} />
                    </Button>
                </Flex>
            </Flex>
            {loading ? (
                <Flex justifyContent='center' alignItems='center' height='50vh'>
                    <Spinner size='xl' />
                </Flex>
            ) : (
                /* Model grid card */
                <ModelCardGrid
                    models={models}
                    setModels={setModels}
                    filters={filters}
                    setFilters={setFilters}
                    modelTypes={modelTypes}
                    setLoading={setLoading}
                />
            )}
            {/* Modal to add new model */}
            <NewModelModal
                isOpen={isOpen}
                onClose={onCloseWithFetch}
                modelTypes={modelTypes}
            />

        </Box>
    );
}